import { ReactNode } from 'react';
import { SubmitButton } from './SubmitButton';

interface Props {
  onClose: () => void;
  onBack?: () => void;
  onNext?: () => void;
  nextLabel?: ReactNode;
  nextDisabled?: boolean;
  saving?: boolean;
  savingLabel?: string;
  /** Replaces the Next/Save button entirely with custom content. */
  actions?: ReactNode;
  nextClassName?: string;
  /** Muted text shown on the left (e.g. why the primary button is disabled). */
  hint?: ReactNode;
  submitTestId?: string;
}

// Standard modal footer. Back button appears only when onBack is provided.
// Cancel is always present. Primary action is either custom `actions` or a
// SubmitButton that says nextLabel (default "Next →") with a saving spinner.
export function ModalFooter({
  onClose,
  onBack,
  onNext,
  nextLabel = 'Next →',
  nextDisabled = false,
  saving = false,
  savingLabel,
  actions,
  nextClassName,
  hint,
  submitTestId = 'modal-submit-btn',
}: Props) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {onBack && (
          <button type="button" className="btn btn-default" onClick={onBack} disabled={saving} data-testid="modal-back-btn">
            ← Back
          </button>
        )}
        {hint && <span className="text-muted small" style={{ textAlign: 'left' }}>{hint}</span>}
      </div>
      <div style={{ display: 'flex', gap: 6 }}>
        <button type="button" className="btn btn-default" onClick={onClose} disabled={saving} data-testid="modal-cancel-btn">
          Cancel
        </button>
        {actions ?? (
          <SubmitButton
            pending={saving}
            pendingLabel={savingLabel ?? 'Saving…'}
            disabled={nextDisabled}
            onClick={onNext}
            type={'submit'}
            className={nextClassName ?? 'btn btn-primary'}
            data-testid={submitTestId}
          >
            {nextLabel}
          </SubmitButton>
        )}
      </div>
    </div>
  );
}
